// router/index.js
import Vue from 'vue'
import Router from 'vue-router'

// 布局组件
import AdminLayout from '@/components/AdminLayout.vue'
import BlankLayout from '@/components/BlankLayout.vue'

// 页面组件（懒加载）
const Login = () => import('@/views/Login.vue')
// const UserManagementView = () => import('@/views/admin/UserManagement.vue')
const RecommendView = () => import('@/views/admin/Recommend.vue')
const WorksView = () => import('@/views/admin/Works.vue')
const TypesView = () => import('@/views/admin/Types.vue')
const NewsView = () => import('@/views/admin/News.vue')
const CenterView = () => import('@/views/admin/Center.vue')
const AboutView = () => import('@/views/admin/About.vue')
const TeamMembersManagementView = () => import('@/views/admin/TeamMembersManagement.vue')

// 引入 Element UI 的 Message 组件
import { Message } from 'element-ui'

Vue.use(Router)

// 创建 router 实例
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: BlankLayout,
      children: [
        {
          path: '',
          component: Login,
          name: 'Login'
        }
      ]
    },
    {
      path: '/admin',
      component: AdminLayout,
      children: [
        // {
        //   path: 'userManagement',
        //   component: UserManagementView,
        //   name: 'UserManagement',
        //   meta: { requiresAuth: true }
        // },
		{
		  path: 'center',
		  component: CenterView,
		  name: 'Center',
		  meta: { requiresAuth: true }
		},
        {
          path: 'recommend',
          component: RecommendView,
          name: 'Recommend',
          meta: { requiresAuth: true }
        },
		{
		  path: 'works',
		  component: WorksView,
		  name: 'Works',
		  meta: { requiresAuth: true }
		},
		{
		  path: 'types',
		  component: TypesView,
		  name: 'Types',
		  meta: { requiresAuth: true }
		},
		{
		  path: 'news',
		  component: NewsView,
		  name: 'News',
		  meta: { requiresAuth: true }
		},
		{
		  path: 'about',
		  component: AboutView,
		  name: 'About',
		  meta: { requiresAuth: true }
		},
		{
		  path: 'teamMembers',
		  component: TeamMembersManagementView,
		  name: 'TeamMembersManagement',
		  meta: { requiresAuth: true }
		}
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const token = localStorage.getItem('token')

  if (requiresAuth && !token) {
    Message.error("登录过期,请重新登录")
    next({ name: 'Login' })
  } else {
    next()
  }
})

// 导出路由实例
export default router